import type { Translation } from '../types.ts';
import type en from '../en/orders.ts';

export default {
    status: {
        pending: 'Wacht op betaling',
        paid: 'Betaald',
        processing: 'In behandeling',
        packing: 'Inpakken',
        fulfilled: 'Verzonden',
        readyForPickup: 'Klaar om af te halen',
        cancelled: 'Geannuleerd',
        refunded: 'Terugbetaald',
    },
    shared: {
        order: 'Bestelling',
        placed: 'Geplaatst',
        customer: 'Klant',
        payment: 'Betaling',
        sendAgain: 'Opnieuw versturen',
    },
    emailKind: {
        orderConfirmation: 'Orderbevestiging',
        shopNotification: 'Melding nieuwe bestelling aan de winkel',
        statusProcessing: 'Status: in behandeling',
        statusPacking: 'Status: inpakken',
        statusFulfilled: 'Status: verzonden',
        statusReadyForPickup: 'Status: klaar om af te halen',
        invoice: 'Factuur',
        creditNote: 'Creditnota',
        giftCard: 'Cadeaubon',
        reviewRequest: 'Verzoek om een review',
    },
    packingSlip: {
        tooMany: 'Je kunt maximaal {max} bestellingen tegelijk afdrukken.',
        failed: 'Pakbon mislukt (HTTP {status})',
    },
    list: {
        title: 'Bestellingen',
        anyStatus: 'Elke status',
        toShip: 'Te verzenden',
        notifyCustomers: 'Klanten e-mailen',
        packingSlips: 'Pakbonnen',
        search: 'Zoeken op e-mail…',
        empty: 'Geen bestellingen die aan deze filters voldoen.',
        clearSelection: 'Selectie wissen',
        selectAll: 'Alles op deze pagina selecteren',
        selectOrder: 'Bestelling {number} selecteren',
        shipsOn: 'verzending {date}',
        delivery: 'bezorging {moment}',
        page: 'Pagina {page} van {pages}',
        count: 'geen bestellingen | {n} bestelling | {n} bestellingen',
        bulk: {
            noneMovable: 'Geen van de geselecteerde bestellingen kan naar {step}.',
            confirmEmail: '{n} bestelling naar {step} verplaatsen? Klanten krijgen een e-mail, behalve bij bol.com-bestellingen. | {n} bestellingen naar {step} verplaatsen? Klanten krijgen een e-mail, behalve bij bol.com-bestellingen.',
            confirmNoEmail: '{n} bestelling naar {step} verplaatsen? Er wordt geen klant gemaild. | {n} bestellingen naar {step} verplaatsen? Er wordt geen klant gemaild.',
            moved: '{n} verplaatst naar {step}',
            skipped: '{n} overgeslagen',
            mailFailed: '{n} e-mail niet verstuurd | {n} e-mails niet verstuurd',
            failed: 'mislukt: {ids}',
        },
    },
    edit: {
        title: 'Bestelling {number}',
        cancelOrder: 'Bestelling annuleren',
        refund: 'Terugbetalen',
        confirmRefund: 'Deze bestelling als terugbetaald markeren? Betaal het bedrag apart terug via het dashboard van de betaalprovider.',
        refunded: 'Bestelling gemarkeerd als terugbetaald',
        paymentReceived: 'Betaling ontvangen',
        confirmPaymentReceived: 'Vastleggen dat het geld voor deze bestelling binnen is?',
        paymentRecorded: 'Betaling vastgelegd',
        confirmCancel: 'Deze openstaande bestelling annuleren? Gereserveerde voorraad komt weer vrij.',
        cancelled: 'Bestelling geannuleerd',
        deleteOrder: 'Bestelling verwijderen',
        confirmDelete: 'Deze onbetaalde bestelling definitief verwijderen? De regels, betaalgeschiedenis, e-mails en notities gaan mee. Dit kan niet ongedaan worden gemaakt.',
        deleted: 'Bestelling verwijderd',
        tabs: {
            order: 'Bestelling',
            slip: 'Pakbon',
            invoice: 'Factuur',
            emails: 'E-mails',
            emailsCount: 'E-mails ({n})',
        },
        summary: {
            title: 'Overzicht',
            shipsFrom: 'Verzending vanaf',
            delivery: 'Bezorgmoment',
            paid: 'Betaald',
            awaitingPayment: 'Nog niet: betaling bij levering',
            shipped: 'Verzonden',
            readyForPickup: 'Klaar om af te halen',
            refunded: 'Terugbetaald',
            guest: 'Gast: {email}',
        },
        steps: {
            title: 'Afhandeling',
            moveTo: 'Naar {step}',
            markReadyForPickup: 'Markeren als klaar om af te halen',
            markShipped: 'Markeren als verzonden',
            notify: 'De klant e-mailen als de bestelling een stap verder gaat',
            bolNote: 'bol.com-bestelling: bol.com houdt de klant op de hoogte, dus de winkel stuurt geen e-mail.',
            trackingHint: 'De trackingcode onder Verzending wordt meteen opgeslagen en komt in de e-mail aan de klant.',
            pickupHint: 'Markeer de bestelling als die klaarligt om af te halen: de klant krijgt dan een e-mail met het afhaaladres.',
            help: 'De klant krijgt de e-mail in de eigen taal. Kies je een eerdere stap, dan gaat de bestelling terug en wordt niemand gemaild. Elke wijziging komt onder Interne notities.',
            moved: 'Verplaatst naar {step}',
            movedEmailed: 'Verplaatst naar {step}; de klant is gemaild',
            movedMailFailed: 'Verplaatst naar {step}, maar de e-mail aan de klant kon niet worden verstuurd. Zie de notitie bij de bestelling.',
        },
        shipment: {
            title: 'Verzending',
            pickup: 'Deze bestelling wordt afgehaald, dus er is niets te volgen.',
            pickupAt: 'Deze bestelling wordt afgehaald bij {location}, dus er is niets te volgen.',
            trackingCode: 'Trackingcode',
            carrier: 'Vervoerder: {carrier}',
            noCarrier: 'Geen vervoerder bekend bij deze bestelling; de code wordt opgeslagen maar kan niet worden gelinkt.',
            openTracking: 'Track & trace openen',
            noLink: 'Opgeslagen. Geen volglink: van de vervoerder van deze bestelling kennen we geen tracking-URL.',
            saved: 'Trackingcode opgeslagen',
        },
        items: {
            title: 'Artikelen',
            product: 'Product',
            qty: 'Aantal',
            unit: 'Stukprijs',
            lineSubtotal: 'Subtotaal regel',
            lineTax: 'Btw regel',
        },
        totals: {
            subtotal: 'Subtotaal',
            discount: 'Korting',
            shipping: 'Verzendkosten',
            tax: 'Btw',
            vatOf: 'waarvan btw {country} {rate}',
            giftCard: 'Cadeaubon',
            paid: 'Betaald',
        },
        vat: {
            title: 'Btw',
            vies: 'VIES-controle van {number} op {date}: {result}',
            consultation: 'raadplegingsnummer {number}',
            notTaxed: 'De engine heeft geen btw berekend over deze bestelling:',
            rate: 'Tarief',
            base: 'Grondslag',
            vat: 'Btw',
            viesResult: {
                valid: 'geldig',
                invalid: 'ongeldig',
                unavailable: 'niet bereikbaar',
            },
            scheme: {
                domestic: 'Nederlandse btw (binnenlandse verkoop)',
                distanceSaleOrigin: 'Nederlandse btw (afstandsverkoop, onder de drempel)',
                distanceSaleDestination: 'Btw van het land van bestemming (afstandsverkoop)',
                intraCommunitySupply: '0% intracommunautaire levering',
                reviewRequired: 'Moet worden beoordeeld',
                unsupported: 'Niet ondersteund',
            },
            treatment: {
                standard: 'standaard',
                reduced: 'verlaagd',
                zeroRated: 'nultarief',
                exempt: 'vrijgesteld',
                intraCommunitySupply: 'intracommunautaire levering',
                outOfScope: 'buiten de reikwijdte',
            },
            reason: {
                merchantProfileMissing: 'Geen goedgekeurd belastingprofiel voor de winkel',
                distanceSalesModeUnconfirmed: 'Nederlandse btw of btw van het land van bestemming voor consumenten in het buitenland is niet bevestigd',
                noDestinationVatRegistration: 'Geen OSS- of lokale btw-registratie voor het land van bestemming',
                viesInvalid: 'Btw-nummer afgewezen door VIES',
                viesUnavailable: 'VIES was niet bereikbaar',
                viesNotChecked: 'Btw-nummer niet gecontroleerd bij VIES',
                vatIdCountryDiffers: 'Btw-nummer is van een ander land dan het afleveradres',
                sellerVatIdMissing: 'De winkel heeft geen Nederlands btw-nummer in zijn profiel',
                productNotClassified: 'Product niet ingedeeld voor btw',
                noTaxRule: 'Geen btw-regel voor het product in dat land',
                overlappingTaxRules: 'Twee btw-regels gelden op dezelfde dag',
                discountExceedsEligible: 'Kortingscode is hoger dan het bedrag waarop die van toepassing is',
                shippingAllocationUndefined: 'Geen goederen om de verzendkosten over te verdelen',
                unsupportedDepartureCountry: 'Goederen worden niet vanuit NL verzonden',
                unsupportedDestinationCountry: 'Bestemming buiten NL en BE',
                unsupportedLineKind: 'Een regel die de engine niet verwerkt',
            },
        },
        address: {
            shipTo: 'Verzendadres',
            billTo: 'Factuuradres',
            vat: 'Btw {number}',
        },
        notes: {
            title: 'Interne notities',
            help: 'Logboek: notities kunnen alleen worden toegevoegd. Niet zichtbaar voor de klant.',
            placeholder: 'Notitie toevoegen…',
            add: 'Notitie toevoegen',
            empty: 'Nog geen notities.',
            delete: 'Notitie verwijderen',
            confirmDelete: 'Deze notitie verwijderen? Dit kan niet ongedaan worden gemaakt.',
            added: 'Notitie toegevoegd',
            deleted: 'Notitie verwijderd',
        },
        timeline: {
            title: 'Betalingsverloop',
            help: 'Logboek van het betalingsverloop, oudste eerst. Geheimen zijn weggelaten.',
            empty: 'Geen betalingsgebeurtenissen vastgelegd.',
            details: 'Details',
            event: {
                orderPlaced: 'Bestelling geplaatst',
                gatewayStart: 'Naar betaalprovider',
                gatewayReturn: 'Terug van betaalprovider',
                webhook: 'Webhook',
                markedPaid: 'Gemarkeerd als betaald',
                acceptedUnpaid: 'Aangenomen, betaling bij levering',
                markedCancelled: 'Gemarkeerd als geannuleerd',
                error: 'Fout',
            },
        },
        emails: {
            title: 'Communicatiegeschiedenis',
            empty: 'Geen e-mails vastgelegd voor deze bestelling. E-mails van vóór 29 september 2026 zijn niet vastgelegd.',
            sent: 'Verstuurd',
            to: 'Aan',
            by: 'Door',
            attached: 'Bijlagen: {files}',
            automatic: 'Automatisch',
            statusSent: 'Verstuurd',
            statusFailed: 'Mislukt',
            asSent: 'Zoals verstuurd',
            plainText: 'Platte tekst',
            noBody: 'Er is niets verstuurd, dus er is geen inhoud om te tonen.',
            sentAgainTo: 'Opnieuw verstuurd naar {recipient}.',
            sendFailed: 'De e-mail kon niet worden verstuurd.',
        },
        slip: {
            print: 'Afdrukken',
            withPrices: 'Met prijzen',
            preview: 'Voorbeeld pakbon',
        },
        invoice: {
            invoiceNumber: 'Factuur {number}',
            creditNoteNumber: 'Creditnota {number}',
            sentTo: 'verstuurd naar {to} {date}',
            notSent: 'niet verstuurd',
            create: 'Factuur aanmaken',
            send: 'Factuur versturen',
            sendCreditNote: 'Creditnota versturen',
            creditNote: 'Creditnota aanmaken',
            previewHelp: 'Voorbeeld hieronder. Bij aanmaken krijgt de factuur het volgende nummer; die gaat pas per e-mail naar {email} als je hem verstuurt.',
            preview: 'Voorbeeld factuur',
            confirmCreate: 'Deze factuur een nummer geven? Een uitgegeven factuur kan niet meer worden gewijzigd. Er wordt nog niets gemaild.',
            confirmSendInvoice: 'Factuur {number} naar {email} e-mailen?',
            confirmSendCreditNote: 'Creditnota {number} naar {email} e-mailen?',
            confirmResendInvoice: 'Factuur {number} opnieuw naar {email} e-mailen?',
            confirmResendCreditNote: 'Creditnota {number} opnieuw naar {email} e-mailen?',
            confirmCreditNote: 'Een creditnota uitgeven die factuur {number} tegenboekt? Er wordt nog niets gemaild.',
            created: 'Factuur aangemaakt',
            creditNoteCreated: 'Creditnota aangemaakt',
            sent: 'Factuur verstuurd',
            sentAgain: 'Opnieuw verstuurd',
            creditNoteSent: 'Creditnota verstuurd',
        },
    },
} satisfies Translation<typeof en>;
